import pako from "pako";
import { decompressFromBase64 } from "lz-string";
export let Buffer = require("buffer").Buffer;

export const isMigrationFromDc = (data) => data?.macroId && data?.data;

const decompress = (base64, options) => {
  try {
    const string = decompressFromBase64(base64, { inputEncoding: "Base64" });
    if (options?.returnString) return string;
    return JSON.parse(string);
  } catch (error) {
    console.log("Failed to decompress ", error);
    return {};
  }
};

const handleRaw = (base64, options) => {
  const data = atob(base64);

  try {
    const jsonString = decodeURIComponent(data);
    if (options?.returnString) return jsonString;
    return JSON.parse(jsonString);
  } catch (error) {
    console.log("Failed to decode or parse ", error);
    return decompress(base64, options);
  }
};

export const convertBase64ToJson = (base64, options) => {
  const compressed = Buffer.from(base64, "base64");

  try {
    const decompressed = pako.inflate(compressed, { to: "string" });
    return decompressed;
  } catch (error) {
    console.log("Failed to pako inflate ", error);
    return handleRaw(base64, options);
  }
};
